import CustomModelVue from './src/CustomModelVue.vue'

CustomModelVue.install = function(Vue) {
    Vue.component(CustomModelVue.name, CustomModelVue)
}

export default CustomModelVue